// extracted by mini-css-extract-plugin
export default {"button":"styles_button__3WdNV","selected":"styles_selected__diMVz","apr":"styles_apr__x+dQC","duration":"styles_duration__Sl33f"};